import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { ZahlartkassaListView } from './list-view/zahlartkassa.list-view';

export const zahlartkassaFieldOk: FieldOkConfig = {
  name: 'zahlartkassa',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlungsart}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlartkassaListView,
      },
    },
  ],
};
export const zahlartkassaMultiselectFieldOk: FieldOkConfig = {
  name: 'zahlartkassa',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlungsart}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlartkassaListView,
      },
    },
  ],
};

export const zahlartkassaQueryFieldOk: FieldOkConfig = {
  name: 'zahlartkassa',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlungsart}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlartkassaListView,
      },
    },
  ],
};
